import SDG1 from "../../../Assets/images/SDG1.png";
import SDG2 from "../../../Assets/images/SDG2.png";
import SDG3 from "../../../Assets/images/SDG3.png";
import SDG4 from "../../../Assets/images/SDG4.png";
import SDG5 from "../../../Assets/images/SDG5.png";
import SDG6 from "../../../Assets/images/SDG6.png";
import SDG7 from "../../../Assets/images/SDG7.png";
import SDG8 from "../../../Assets/images/SDG8.png";
import SDG9 from "../../../Assets/images/SDG9.png";
import SDG11 from "../../../Assets/images/SDG11.png";
import SDG12 from "../../../Assets/images/SDG12.png";
import SDG13 from "../../../Assets/images/SDG13.png";
import SDG15 from "../../../Assets/images/SDG15.png";
import SDG16 from "../../../Assets/images/SDG16.png";
import SDG17 from "../../../Assets/images/SDG17.png";

export const SDGOptions = {
	SDG1: SDG1,
	SDG2: SDG2,
	SDG3: SDG3,
	SDG4: SDG4,
	SDG5: SDG5,
	SDG6: SDG6,
	SDG7: SDG7,
	SDG8: SDG8,
	SDG9: SDG9,
	SDG11: SDG11,
	SDG12: SDG12,
	SDG13: SDG13,
	SDG15: SDG15,
	SDG16: SDG16,
	SDG17: SDG17,
};
